import { create } from 'zustand'
import { createViewerSlice, type ViewerSlice } from '@viewer/store/viewerSlice'
import { createSelectionSlice, type SelectionSlice } from '@viewer/store/selectionSlice'
import { createPopupsSlice, type PopupsSlice } from '@viewer/store/popupsSlice'
import { createSectionSlice, type SectionSlice } from '@viewer/store/sectionSlice'
import { createIfcDiffSlice, type IfcDiffSlice } from '@viewer/store/ifcDiffSlice'
import { createIdsSlice, type IdsSlice } from '@viewer/store/idsSlice'
import {
  createExtraPanelsSlice,
  type ExtraPanelsSlice,
} from '@viewer/store/extraPanelsSlice'
import { createMeasureSlice, type MeasureSlice } from '@viewer/store/measureSlice'
import {
  createAnnotationsSlice,
  type AnnotationsSlice,
} from '@viewer/store/annotationsSlice'
import {
  createViewpointsSlice,
  type ViewpointsSlice,
} from '@viewer/store/viewpointsSlice'
import {
  createViews2DSlice,
  type Views2DSlice,
} from '@viewer/store/views2dSlice'
import {
  createClashSlice,
  type ClashSlice,
} from '@viewer/clash/store/clashSlice'
import {
  createWorkspaceLayoutSlice,
  type WorkspaceLayoutSlice,
} from './workspaceLayoutSlice'
import {
  createSessionRestoreSlice,
  type SessionRestoreSlice,
} from '@core/session/sessionRestoreSlice'
import {
  createBcfClientSlice,
  type BcfClientSlice,
} from '@modules/bcf/store/bcfClientSlice'
import { createBoqSlice, type BoqSlice } from '@modules/boq/store/boqSlice'
import {
  createIfcEditSlice,
  type IfcEditSlice,
} from '@modules/ifc-edit/store/ifcEditSlice'
import {
  createInfoTableSlice,
  type InfoTableSlice,
} from '@modules/info-table/store/infoTableSlice'
import {
  createIdsModuleSlice,
  type IdsModuleSlice,
} from '@modules/ids/store/idsModuleSlice'
import {
  createAssistantSlice,
  type AssistantSlice,
} from '@modules/assistant/store/assistantSlice'
import { createHistorySlice, type HistorySlice } from './historySlice'
import { createToastSlice, type ToastSlice } from './toastSlice'

export type AppStore = ViewerSlice &
  SelectionSlice &
  PopupsSlice &
  SectionSlice &
  WorkspaceLayoutSlice &
  SessionRestoreSlice &
  IfcDiffSlice &
  IdsSlice &
  ExtraPanelsSlice &
  ViewpointsSlice &
  Views2DSlice &
  ClashSlice &
  MeasureSlice &
  AnnotationsSlice &
  BcfClientSlice &
  BoqSlice &
  IfcEditSlice &
  InfoTableSlice &
  IdsModuleSlice &
  AssistantSlice &
  HistorySlice &
  ToastSlice

export const useAppStore = create<AppStore>()((...a) => ({
  ...createViewerSlice(...a),
  ...createSelectionSlice(...a),
  ...createPopupsSlice(...a),
  ...createSectionSlice(...a),
  ...createWorkspaceLayoutSlice(...a),
  ...createSessionRestoreSlice(...a),
  ...createIfcDiffSlice(...a),
  ...createIdsSlice(...a),
  ...createExtraPanelsSlice(...a),
  ...createViewpointsSlice(...a),
  ...createViews2DSlice(...a),
  ...createClashSlice(...a),
  ...createMeasureSlice(...a),
  ...createAnnotationsSlice(...a),
  ...createBcfClientSlice(...a),
  ...createBoqSlice(...a),
  ...createIfcEditSlice(...a),
  ...createInfoTableSlice(...a),
  ...createIdsModuleSlice(...a),
  ...createAssistantSlice(...a),
  ...createHistorySlice(...a),
  ...createToastSlice(...a),
}))
